import { render, staticRenderFns } from "./new.events.page.vue?vue&type=template&id=c0e15902&"
import script from "./new.events.page.vue?vue&type=script&lang=js&"
export * from "./new.events.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports